<template>
    <div class="w-full overflow-x-auto border">
        <table-layout class="w-full whitespace-no-wrap" :loading="loading">
            <template v-slot:theadRow>
                <th class="px-4 py-3 text-left">Name</th>
                <th class="px-4 py-3">Status</th>
                <th class="px-4 py-3 text-center" v-if="canInviteRespondents">Resend Invitation</th>
            </template>
            <template v-slot:tbody v-if="paginatedRespondents.data.length">
                <tr class="text-gray-700 dark:text-gray-400"
                    v-for="respondent in paginatedRespondents.data" :key="'respondent-row-' + respondent.id">
                    <td class="px-4 py-3 w-1/2 text-sm text-left">
                        <h4 class="text-base font-semibold whitespace-normal">{{ respondent.email }}</h4>
                    </td>
                    <td class="px-4 py-3 text-sm">
                                    <span v-if="respondent.started_at === null"
                                          class="px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-full dark:text-red-100 dark:bg-red-700">
                                      Not Started
                                    </span>
                        <span v-else-if="respondent.started_at !== null && respondent.finished_at === null"
                              class="px-2 py-1 font-semibold leading-tight text-orange-700 bg-orange-100 rounded-full dark:bg-orange-700 dark:text-orange-100">
                                      Started
                                    </span>
                        <span v-else
                              class="px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100">
                                      Finished
                                    </span>
                    </td>
                    <td class="px-4 py-3 text-center" v-if="canInviteRespondents">
                        <button @click.prevent="sendInvite(respondent.id)"
                                class="mx-auto flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-0 active:bg-red-0 hover:bg-red-0h border border-transparent rounded-full  focus:outline-none"
                                :class="respondent.finished_at === null ? '' : 'opacity-60 pointer-events-none'"
                                aria-label="Resend invitation">
                            <svg class="w-4 h-4" aria-hidden="true" focusable="false" data-prefix="fas"
                                 data-icon="share"
                                 role="img"
                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path fill="white"
                                      d="M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"></path>
                            </svg>
                        </button>
                    </td>
                </tr>
            </template>
            <template v-slot:tbody v-else>
                <tr class="text-center text-gray-700 dark:text-gray-400">
                    <td colspan="5">
                        No respondents
                    </td>
                </tr>
            </template>
        </table-layout>
    </div>
    <div class="p-3 bg-gray-50 border">
        <table-pagination :preserve-scroll="true"
                          :pagination-object="paginatedRespondents"
                          @start-visit="loading=true"
                          @finish-visit="loading=false"
                          :inertia-visit-options="{only: ['paginatedRespondents']}"/>
    </div>
</template>

<script>
import TablePagination from "@/Jetstream/TablePagination";
import TableLayout from "@/Jetstream/TableLayout";
import {Inertia} from "@inertiajs/inertia";
import {ref, inject} from "vue";

export default {
    name: 'SurveyRespondentsTable',
    components: {
        TablePagination,
        TableLayout,
    },
    props: {
        paginatedRespondents: {
            type: Object,
            required: true,
        },
        canInviteRespondents: {
            type: Boolean,
            default: false,
        },
        survey: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const loading =  ref(false);
        const $swal = inject('$swal');
        const sendInvite = (respondent) => {
            $swal({
                title: 'Are you sure?',
                text: `Respondent ${respondent.email} will be notified!`,
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, send it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.put(route('tenant.survey.remind-respondents', {
                        survey: props.survey.id,
                        tenant: props.survey.tenant_id,
                        respondent
                    }), {}, {
                        preserveScroll: true,
                    });
                }
            });
        };

        return {
            sendInvite,
            loading,
        };
    }
}
</script>
